import React, { Component } from "react";
import { Route, BrowserRouter, Switch } from "react-router-dom";

import { createMuiTheme, createTypography } from "@material-ui/core/styles";
import MuiThemeProvider from "@material-ui/core/styles/MuiThemeProvider";

import AdminAuthenticationContainer from "./component/common/AdminComponent/AdminAuthenticationContainer";
import Trainers from "./component/common/AdminComponent/Trainers";
import Subscription_Schedule_Trainer from "./component/common/AdminComponent/Subscription_Schedule_Trainer";
import InvoiceTrainer from "./component/common/AdminComponent/InvoiceTrainer";
import TrainerProfile from "./component/common/AdminComponent/TrainerProfile";
import AdminProteinGuide from "./component/common/AdminComponent/AdminProteinGuide";
import FormProteinGuide from "./component/common/AdminComponent/FormProteinGuide";
import DiscountCode from "./component/common/AdminComponent/DiscountCode";
import FormDiscountCode from "./component/common/AdminComponent/FormDiscountCode";
import AdminOffers from "./component/common/AdminComponent/AdminOffers";
import FormOffers from "./component/common/AdminComponent/FormOffers";
import AdminStore from "./component/common/AdminComponent/AdminStore";
import FormAdminStore from "./component/common/AdminComponent/FormAdminStore";
import GetLinkApp from './component/common/UserComponent/GetLinkApp'
import AdminStoreSaleReport from "./component/common/AdminComponent/AdminStoreSaleReport";
import ListContactUsUser from "./component/common/AdminComponent/ListContactUsUser";
import AdminListOrders from "./component/common/AdminComponent/AdminListOrders";
import AdminUser from "./component/common/AdminComponent/AdminUser";

import FormCourse from "./component/common/AdminComponent/FormCourse";
import AdminCourse from "./component/common/AdminComponent/AdminCourse";
import SubsCount from "./component/common/AdminComponent/SubsCount";
import Charts from "./component/common/AdminComponent/SubsCount/Charts";
import Notfications from "./component/common/AdminComponent/Notfications";
import SubsCounts from "./component/common/AdminComponent/SubsCount/SubsCounts";
import AdminSubscriptionCourse from "./component/common/AdminComponent/AdminSubscriptionCourse";
import AdminCpStoreWallet from "./component/common/AdminComponent/AdminCpStoreWallet";
import AdminCpConsulting from "./component/common/AdminComponent/AdminCpConsulting";

import WebViewPayment from './component/common/UserComponent/WebViewPayment'

import AdminSubscriptionSchedule from "./component/common/AdminComponent/AdminSubscriptionSchedule";

import LandingPage from "./component/common/UserComponent/LandingPage";
import LandingPageTwo from "./component/common/UserComponent/LandingPageTwo"



const themeColor = createMuiTheme({
  palette: {
    primary: {
      main: "#b1d236",
    },
    secondary: {
      main: "#74cbc4",
    },
    typography: {
      fontFamily: ["DIN-NEXT™-ARABIC-BOLD", "sans-serif", ,].join(","),
    },
  },
});

const AppRouter = () => (
  <MuiThemeProvider theme={themeColor} mu>
    <BrowserRouter >
      
        <Switch >



          <Route path="/GetLinkApp" component={GetLinkApp}></Route>
          <Route path="/Protein" component={LandingPage}></Route>
          <Route path="/Protein1" component={LandingPageTwo}></Route>


          <Route path="/WebViewPayment" component={WebViewPayment}></Route>


          {/* Admin */}
          <Route
            path="/Admin/AdminLogin"
            component={AdminAuthenticationContainer}
          ></Route>
          <Route path="/Admin/Trainers" component={Trainers}></Route>
          <Route
            path="/Admin/Subscription_Schedule_Trainer"
            component={Subscription_Schedule_Trainer}
          ></Route>
          <Route
            path="/Admin/InvoiceTrainer"
            component={InvoiceTrainer}
          ></Route>
          <Route
            path="/Admin/TrainerProfile"
            component={TrainerProfile}
          ></Route>
          <Route
            path="/Admin/AdminProteinGuide"
            component={AdminProteinGuide}
          ></Route>
          <Route
            path="/Admin/FormProteinGuide"
            component={FormProteinGuide}
          ></Route>
          <Route path="/Admin/DiscountCode" component={DiscountCode}></Route>
          <Route
            path="/Admin/FormDiscountCode"
            component={FormDiscountCode}
          ></Route>
          <Route path="/Admin/AdminOffers" component={AdminOffers}></Route>
          <Route path="/Admin/FormOffers" component={FormOffers}></Route>
          <Route path="/Admin/AdminStore" component={AdminStore}></Route>
          <Route path="/Admin/SubsCount" component={SubsCount}></Route>
          <Route path="/Admin/tables" component={SubsCounts}></Route>
          <Route path="/Admin/Charts" component={Charts}></Route>
          <Route path="/Admin/Notfications" component={Notfications}></Route>
          <Route
            path="/Admin/FormAdminStore"
            component={FormAdminStore}
          ></Route>
          <Route
            path="/Admin/AdminStoreSaleReport"
            component={AdminStoreSaleReport}
          ></Route>
          <Route
            path="/Admin/ListContactUsUser"
            component={ListContactUsUser}
          ></Route>
          <Route
            path="/Admin/AdminListOrders"
            component={AdminListOrders}
          ></Route>
          <Route path="/Admin/AdminUser" component={AdminUser}></Route>
          <Route path="/Admin/FormCourse" component={FormCourse}></Route>
          <Route path="/Admin/AdminCourse" component={AdminCourse}></Route>
          <Route
            path="/Admin/AdminSubscriptionCourse"
            component={AdminSubscriptionCourse}
          ></Route>
          <Route
            path="/Admin/AdminCpStoreWallet"
            component={AdminCpStoreWallet}
          ></Route>
          
          <Route
            path="/Admin/AdminCpConsulting"
            component={AdminCpConsulting}
          ></Route>
          <Route
            path="/Admin/AdminSubscriptionSchedule"
            component={AdminSubscriptionSchedule}
          ></Route>
        </Switch>
      
    </BrowserRouter>
  </MuiThemeProvider>
);



export default AppRouter

